import React from 'react';
import classNames from 'classnames';

import './Button1.scss';
import { Colors } from '../../Tenants';

const Button1 = ({
  block,
  color,
  disabled,
  icon,
  label,
  onClick,
  size,
  outline,
  weight,
}) => (
  <button
    disabled={disabled}
    onClick={onClick}
    className={
      classNames(
        'button1',
        {
          [`button1--${color}`]: color,
          [`button1--${size}`]: size,
          [`button1--${weight}`]: weight,
          [`button1--outline-${outline}`]: outline,
          'button1--disabled': disabled,
          'button1--block': block,
        }
      )
    }
  >
    <div className="button1__body">
      {icon && (
        <div className="button1__icon">
          {icon}
        </div>
      )}
      {label && (
        <div className="button1__label" style={{color: Colors.buttonTextColor}}
        >
          {label}
        </div>
      )}
    </div>
  </button>
);

export default Button1; 
